export enum ZoomType {
  IN = 'in',
  OUT = 'out',
}

export enum MapType {
  ROADMAP = 'roadmap',
  HYBRID = 'hybrid',
  SATELLITE = 'satellite',
}

export enum ControlPositionType {
  TOP_LEFT = 'topleft',
  TOP_RIGHT = 'topright',
  BOTTOM_LEFT = 'bottomleft',
  BOTTOM_RIGHT = 'bottomright',
}

export type Position = {
  lat: number;
  lng: number;
};
